import "./OcipError.css";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Button, Table } from "react-bootstrap";
import { getIvFieldValue } from "../../utils/ivErrorDataUtils";

/**
 * WILLINGS GCI-M10 Fault Map
 * 규칙:
 *   0 = NORMAL
 *   1 = FAULT
 */
const AlarmModalData = {
  0: {
    title: "태양전지 상태 (0x0000)",
    rows: [
      { bit: "Bit0", desc: "과전압", code: "0x0001" },
      { bit: "Bit2", desc: "저전압", code: "0x0004" },
      { bit: "Bit15", desc: "전체 상태", code: "0x8000" },
    ],
  },
  1: {
    title: "계통 상태 (0x0002)",
    rows: [
      { bit: "Bit0", desc: "과전압", code: "0x0001" },
      { bit: "Bit1", desc: "저전압", code: "0x0002" },
      { bit: "Bit2", desc: "과주파수", code: "0x0004" },
      { bit: "Bit3", desc: "저주파수", code: "0x0008" },
      { bit: "Bit4", desc: "정전", code: "0x0010" },
      { bit: "Bit5", desc: "지락", code: "0x0020" },
      { bit: "Bit15", desc: "전체 상태", code: "0x8000" },
    ],
  },
};

const WillingsFault = ({ SelInverter }) => {
  const ivData = useSelector((state) => state.ivData || {});
  const [openModalNum, setOpenModalNum] = useState(null);

  const closeModal = () => setOpenModalNum(null);

  const getFaultValue = (num) => {
    switch (num) {
      case 0:
        return Number(getIvFieldValue(ivData, "fault0", SelInverter, 0)) || 0;
      case 1:
        return Number(getIvFieldValue(ivData, "fault1", SelInverter, 0)) || 0;
      default:
        return 0;
    }
  };

  const parseBitFlags = (value) => {
    const n = Number(value) || 0;
    const flags = {};
    for (let i = 0; i <= 15; i++) {
      flags[`Bit${i}`] = (n >> i) & 1;
    }
    return flags;
  };

  const isBitFault = (bitVal) => (Number(bitVal) || 0) === 1;

  const isAbnormalGroup = (groupNum, value) => {
    const modal = AlarmModalData[groupNum];
    if (!modal) return false;
    const bits = parseBitFlags(value);
    return modal.rows.some((row) => isBitFault(bits[row.bit] ?? 0));
  };

  const renderModalContent = () => {
    const modal = AlarmModalData[openModalNum];
    if (!modal) return null;

    const rawValue = getFaultValue(openModalNum);
    const bits = parseBitFlags(rawValue);

    return (
      <>
        <Modal.Header closeButton>
          <Modal.Title>
            {modal.title} (0x{rawValue.toString(16).toUpperCase()})
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Table striped bordered size="sm">
            <thead>
              <tr>
                <th>Bit</th>
                <th>Description</th>
                <th>Mask</th>
                <th>Value</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {modal.rows.map((row, idx) => {
                const bitVal = bits[row.bit] ?? 0;
                const fault = isBitFault(bitVal);

                return (
                  <tr key={idx} className={fault ? "active-row" : ""}>
                    <td>{row.bit}</td>
                    <td>{row.desc}</td>
                    <td>{row.code}</td>
                    <td>{bitVal}</td>
                    <td>{fault ? "FAULT" : "NORMAL"}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            닫기
          </Button>
        </Modal.Footer>
      </>
    );
  };

  const items = [
    { label: "태양전지 상태", num: 0 },
    { label: "계통 상태", num: 1 },
  ];

  return (
    <div className="status-list-container">
      <div className="status-list">
        {items.map(({ label, num }) => {
          const value = getFaultValue(num);
          const abnormal = isAbnormalGroup(num, value);

          return (
            <div key={num} className="status-item">
              <span className="status-value">
                {label}: {value}
              </span>
              <button onClick={() => setOpenModalNum(num)}>
                <span className={abnormal ? "blinking-icon" : ""}>
                  {abnormal ? "🔴" : "🟢"}
                </span>
              </button>
            </div>
          );
        })}
      </div>

      {openModalNum !== null && (
        <Modal show onHide={closeModal} size="lg">
          {renderModalContent()}
        </Modal>
      )}
    </div>
  );
};

export default WillingsFault;
